<template>
  <div class="block">
    <el-date-picker
      v-model="date"
      type="datetimerange"
      :picker-options="pickerOptions"
      range-separator="~"
      start-placeholder="Start date"
      end-placeholder="End date"
      @change="dataChanged"
      align="left">
    </el-date-picker>
  </div>
</template>

<script type="text/babel">
import moment from 'moment';
export default {
    props: ['dateRange'],
    created (){
        this.date = this.dateRange;
    },
    data () {
        return {
            date: [],
            pickerOptions: {
                disabledDate (date) {
                    return date < new Date(new Date().setFullYear(new Date().getFullYear() - 1)) || date > new Date();
                },
                shortcuts: [{
                    text: 'Last week',
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: 'Last month',
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: 'Last 3 months',
                    onClick (picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            }
        };
    },
    methods: {
        dataChanged () {
            this.$emit('dateChanged', this.date);
        }
    }
};
</script>

<style lang="scss" scoped>
    label {
        float: none;
    }
    .picker{
        display: inline-block;
    }
</style>
